module.exports = __webpack_public_path__ + "media/images/stock_groups/ea52-dee8bd0f62b54e4c7a77887b7a731e9b.svg";